module.exports = __webpack_public_path__ + "static/img/2.dd01814.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/zh/2.png
// module id = IaEf
// module chunks = 0